import { AppSider } from 'shared/UI/UIKit/Sider';
import { TableFilter } from 'common/TableFilter';
import {
  CreateTeacherWorkloadModal,
  EditTeacherWorkloadModal,
  RemoveTeacherWorkloadModal,
  CopyTeacherWorkloadModal,
} from 'entities/teacher-workload';
import { useTeacherWorkloads } from '../model';
import { TeacherWorkloadControls } from './components';
import { TeacherWorkloadsTable } from './TeacherWorkloadsTable';

export const TeacherWorkloads = () => {
  const {
    state: {
      columns,
      visibleKeys,
      loading,
      teacherWorkloads,
      filteredColumns,
      createModalVisible,
      copyModalVisible,
      editModalVisible,
      selectedWorkload,
      removeModalVisible,
      tableState,
      filterState,
      filterCount,
      siderVisible,
      filterFields,
      pageSize,
    },
    methods: {
      showCreateModal,
      hideCreateModal,
      hideEditModal,
      hideDeleteModal,
      setVisibleKeys,
      refreshPage,
      hideCopyModal,
      onItemRemove,
      onTableChange,
      onFilterChange,
      showSider,
      hideSider,
      onLoadFilterOptions,
      onPaginationChange,
    },
  } = useTeacherWorkloads();

  return (
    <>
      <TeacherWorkloadControls
        onCreateTeacherWorkload={showCreateModal}
        columns={columns}
        visibleKeys={visibleKeys}
        setVisibleKeys={setVisibleKeys}
        filterCount={filterCount}
        showSider={showSider}
      />
      <TeacherWorkloadsTable
        loading={loading}
        dataSource={teacherWorkloads}
        columns={filteredColumns}
        tableState={tableState}
        onChange={onTableChange}
        pageSize={pageSize}
        onPaginationChange={onPaginationChange}
      />

      <CreateTeacherWorkloadModal
        visible={createModalVisible}
        hide={hideCreateModal}
        onSuccess={refreshPage}
      />

      <EditTeacherWorkloadModal
        visible={editModalVisible}
        hide={hideEditModal}
        onSuccess={refreshPage}
        workload={selectedWorkload}
      />

      <RemoveTeacherWorkloadModal
        visible={removeModalVisible}
        hide={hideDeleteModal}
        onSuccess={onItemRemove}
        workload={selectedWorkload}
      />

      <CopyTeacherWorkloadModal
        visible={copyModalVisible}
        hide={hideCopyModal}
        onSuccess={refreshPage}
        workload={selectedWorkload}
      />

      <AppSider
        title="Фильтры"
        isSiderVisible={siderVisible}
        submitBtnText="Применить"
        cancelBtnText="Сбросить всё"
        hideSider={hideSider}
      >
        <TableFilter
          fields={filterFields}
          submitBtnText="Применить"
          resetBtnText="Сбросить всё"
          onSubmit={onFilterChange}
          onClose={hideSider}
          fieldsValue={filterState}
          onLoadOptions={onLoadFilterOptions}
        />
      </AppSider>
    </>
  );
};
